import { render, staticRenderFns } from "./DelShop.vue?vue&type=template&id=29051f8b"
import script from "./DelShop.vue?vue&type=script&lang=js"
export * from "./DelShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports